/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="84.25"
        viewBox="0 0 95.58 84.25"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M44.86 6.28V8.5h-.36l-.34.07a5.3 5.3 0 0 0-4 3.23 6.71 6.71 0 0 0-.46 3 5.17 5.17 0 0 0 2.8 4.44 22.9 22.9 0 0 0 2.31 1c1 .4 2 .78 2.91 1.19a1.74 1.74 0 0 1 1.1 1.92 1.92 1.92 0 0 1-1.54 1.93 5.56 5.56 0 0 1-1.22.13 3 3 0 0 1-3.11-2.27c-.08-.27-.15-.55-.23-.84l-3.69.95a7.63 7.63 0 0 0 1.78 3.65 6.23 6.23 0 0 0 4.05 1.86v2.85h2.38v-2.78c.48-.1 1-.17 1.4-.29a5.48 5.48 0 0 0 3.86-3.15 6.45 6.45 0 0 0 .48-3.89 5.1 5.1 0 0 0-2.58-3.66 30.65 30.65 0 0 0-3.53-1.54c-.73-.29-1.43-.62-2.13-1a1.54 1.54 0 0 1-.79-1 2.15 2.15 0 0 1 1.55-2.6 2.5 2.5 0 0 1 2.46.65 4.87 4.87 0 0 1 1 1.52c.08.18.15.36.24.55l3.3-1.36a6.7 6.7 0 0 0-1.21-2.49 5.85 5.85 0 0 0-4-2.09v-2.2Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M68.01 0a1.25 1.25 0 0 1 1.24 1.12v35.63h-2.5V2.5h-41.8v35.3H22.5V1.25A1.24 1.24 0 0 1 23.62.01h44.39Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M85.4 35.5a12.46 12.46 0 0 1 3.78.54 9.19 9.19 0 0 1 4.65 3 8.06 8.06 0 0 1 1.75 5.09 10.14 10.14 0 0 1-.62 3.42l-.15.38L81.6 81.29a4.88 4.88 0 0 1-4.42 3H4.56v-2.5h72.39a2.48 2.48 0 0 0 2.26-1.23l.06-.14L92.5 46.99a7.69 7.69 0 0 0 .59-2.88 5.57 5.57 0 0 0-1.19-3.52 6.87 6.87 0 0 0-3.4-2.19 9.8 9.8 0 0 0-2.64-.42H29.5a16.51 16.51 0 0 0-8.72 2.74 14.49 14.49 0 0 0-5.53 6.13l-.13.31-9.78 24.7-2.73 7.05a2.11 2.11 0 0 0-.15.77 2.08 2.08 0 0 0 1.91 2.08h.15v2.5a4.57 4.57 0 0 1-4.56-4.58 4.71 4.71 0 0 1 .22-1.4l.1-.27 2.74-7.06 9.78-24.71a16.67 16.67 0 0 1 6.7-7.63 19 19 0 0 1 9.62-3.11H85.4Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M23.65 18.59v2.5H9.8c-4 0-7.16 2.68-7.3 5.92V79.7H0V27.22c0-4.72 4.28-8.5 9.51-8.63h14.14ZM72.57 24.35c5.2 0 9.64 3.9 9.79 8.66v3.71h-2.5v-3.46c0-3.35-3.19-6.28-7-6.4h-4.82v-2.5Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'FolderWithPaperMoneyIcon';

export default Icon;
